function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.559 3.259a6.276 6.276 0 0 1-2.086.856C14.875 3.43 14.022 3 13.077 3c-1.811 0-3.281 1.583-3.281 3.534 0 .277.028.546.084.805-2.728-.148-5.146-1.553-6.766-3.694a3.739 3.739 0 0 0-.445 1.779c0 1.225.58 2.307 1.461 2.941a3.108 3.108 0 0 1-1.488-.44v.043c0 1.713 1.132 3.142 2.635 3.465a3.051 3.051 0 0 1-1.483.062c.418 1.404 1.63 2.426 3.066 2.453-1.123.949-2.54 1.514-4.077 1.514-.265 0-.527-.016-.783-.049A8.83 8.83 0 0 0 7.032 17c6.039 0 9.34-5.385 9.34-10.055 0-.154-.003-.308-.009-.458A6.943 6.943 0 0 0 18 4.657c-.588.281-1.22.471-1.885.557a3.508 3.508 0 0 0 1.444-1.955"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.886e567f.svg";
export { ForwardRef as ReactComponent };